import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { IdentityPublicPath } from '../lib/constants'

const publicConfig = { skipUnauthorizedRedirect: true } as const

export interface PublicDeletionStartData {
  message?: string
  maskedEmail?: string | null
  otpExpiresAt?: string | null
}

export interface PublicDeletionVerifyData {
  message?: string
  graceDays?: number
  scheduledPurgeAt?: string
  deletion?: {
    scheduledPurgeAt?: string
    graceDays?: number
    deletionRequestId?: string
    balanceForfeitedUsd?: number
  }
}

export function usePublicDeletionStart() {
  return useMutation({
    mutationFn: async (body: { email: string; turnstileToken?: string }) => {
      const { data } = await apiClient.post<ApiResponse<PublicDeletionStartData>>(
        IdentityPublicPath.DELETION_EMAIL_START,
        body,
        publicConfig
      )
      return data.data
    },
  })
}

export function usePublicDeletionResend() {
  return useMutation({
    mutationFn: async (body: { email: string }) => {
      const { data } = await apiClient.post<ApiResponse<PublicDeletionStartData>>(
        IdentityPublicPath.DELETION_EMAIL_RESEND,
        body,
        publicConfig
      )
      return data.data
    },
  })
}

export function usePublicDeletionVerify() {
  return useMutation({
    mutationFn: async (body: { email: string; code: string; confirm: boolean }) => {
      const idempotencyKey = crypto.randomUUID()
      const { data } = await apiClient.post<ApiResponse<PublicDeletionVerifyData>>(
        IdentityPublicPath.DELETION_EMAIL_VERIFY,
        body,
        {
          ...publicConfig,
          headers: { 'Idempotency-Key': idempotencyKey },
        }
      )
      return data.data
    },
  })
}
